import i18next from 'i18next';
import lang from '@/utils/getUALang';

const context = require.context('../../public/strings', true, /\.json$/);

export const createI18n = async (language: 'en' | 'id' = lang) => {
  const _path = `./${process.env.SHOPEE_COUNTRY}/${language}.json`;
  i18next.init({
    lng: language,
    resources: {
      [language]: { translation: context(_path) },
    },
    keySeparator: false,
  });
  return i18next;
};

export default i18next;
